<template>
    <v-dialog width="450px" v-model="dialog">

        <template v-slot:activator="{ on }" class="primary">
            <v-btn
                v-on="on"
                :disabled="INTERVAL_DAY == intervalId"
            >
              <v-icon>mdi-content-copy</v-icon>&nbsp;Copy Shifts
            </v-btn>
        </template>

        <v-card v-if="dialog">
            <v-card-title>
                <span class="headline">Copy shifts from: {{shiftsRangeText}}</span>
                <div class="dialog-closeBtn" @click="dialog = false"><v-icon left>mdi-close</v-icon></div>
            </v-card-title>
            <!-- <v-card-text> -->
                <v-row>
                    <v-col>
                        Please select period where to copy current shifts:
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-date-picker
                            v-model="date_range_selected"
                            scrollable
                            actions
                            full-width
                            first-day-of-week="1"
                            range
                            :title-date-format="dateRangeText"
                            v-on:click:date="dateRangeSelect"
                        ></v-date-picker>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <div class="d-flex justify-center">
                            <v-btn
                                    depressed
                                    class="mr-4 primary"
                                    :disabled="localLoading || isShiftsEmpty"
                                    :loading="localLoading"
                                    @click="submit"
                            ><v-icon left>mdi-content-copy</v-icon>Make Copy of Shifts</v-btn>
                            <v-btn
                                    class="warning"
                                    :loading="localLoading"
                                    depressed
                                    @click="dialog=false"
                            ><v-icon left>mdi-cancel</v-icon>Cancel</v-btn>
                        </div>
                    </v-col>
                </v-row>
            <!-- </v-card-text> -->
        </v-card>
        
    </v-dialog>
</template>

<script>
import moment from 'moment';
import * as _ from 'lodash';
import { DATE_RANGE_HELPERS,
    INTERVAL_DAY, INTERVAL_WEEK, INTERVAL_TWO_WEEK, INTERVAL_MONTH } from '../../store/shifts';

export default {
    name: "CopyShiftsModal",
    props: ['shiftList', 'intervalId', 'dateRangeSelected'],
    data: () => ({
        readOnly: false,
        localLoading: false,
        dialog: false,
        // --
        date_range_selected: null,
        INTERVAL_DAY: INTERVAL_DAY,
    }),
    watch: {
        dialog: function(val) {
            if (val) {
                let shifts_date = moment();
                if (!this.isShiftsEmpty) { // get any shifts date (from copy to copy)
                    shifts_date = moment(this.$props.shiftList[0].period_date, "YYYY-MM-DD");
                }

                switch(this.$props.intervalId) {
                    case INTERVAL_DAY:
                        alert('unready');
                        break;
                    case INTERVAL_WEEK:
                        shifts_date.add(1, 'weeks');
                        break;
                    case INTERVAL_TWO_WEEK:
                        shifts_date.add(2, 'weeks');
                        break;
                    case INTERVAL_MONTH:
                        shifts_date.add(1, 'months');
                        break;
                }

                this.$data.date_range_selected = this.dateRangeSelected; // [shifts_date.format('YYYY-MM-DD'), null];
                this.dateRangeSelect();
            }
        }
    },
    created() {
        // let current_date = moment();
        this.$data.date_range_selected = this.dateRangeSelected; // [current_date.format('YYYY-MM-DD'), null];
    },
    updated() {
        //--
    },
    computed: {
        isShiftsEmpty() {
            return _.isEmpty(this.$props.shiftList);
        },
        shiftsRangeText() {
            if (this.isShiftsEmpty) {
                return 'no shifts';
            }

            // get any shifts date
            // let shifts_date = moment(this.$props.shiftList[0].period_date, "YYYY-MM-DD");
            // let shifts_range = this.dayToRange([shifts_date.format('YYYY-MM-DD'), null], this.$props.intervalId);
            let shifts_range = this.dayToRange(this.dateRangeSelected, this.$props.intervalId);

            return DATE_RANGE_HELPERS.dateRangeText(shifts_range);
        }
    },

    methods: {
        submit () {
            this.localLoading = true;

            this.$store.dispatch('copyShiftsFree', {shifts: this.$props.shiftList, to_date: this.$data.date_range_selected[0], /*, interval_id: this.$props.intervalId*/}).then(() => {
                this.dialog = false;
            }).finally(() => {
                this.localLoading = false;
            });
        },
        dateRangeSelect: async function() {
            this.$data.date_range_selected = this.dayToRange(this.$data.date_range_selected[0], this.$props.intervalId);
            
            // fetch shifts from server
            // await this.$store.dispatch('fetchShifts', {
            //     period_date_from: this.$data.date_range_selected[0],
            //     period_date_to: this.$data.date_range_selected[1]
            // });
        },
        // -- helpers:
        dayToRange: function(date, interval_id) {
            return DATE_RANGE_HELPERS.dayToRange(date, interval_id)
        },
        dateRangeText: function (date_range_selected) {
            return "to: " + DATE_RANGE_HELPERS.dateRangeText(date_range_selected)
        },
    },
}
</script>

<style scoped>

</style>